import { Button, styled } from '@mui/material'
import { transientOptions } from '../../../styles/TransientOptions'
import { ReactComponent as ArrrowSvg } from './assets/arrow.svg'

export const ChainName = styled('div')`
  flex: 1;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) => props.theme.breakpoints.down('lg')} {
    min-width: 60px;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const SwitchNetwork = styled(ChainName)`
  ${(props) => props.theme.breakpoints.down('md')} {
    display: inline;

    span {
      display: none;
    }
  }
`
export const CurrentNetwork = styled('div', transientOptions)<{
  $isErrorChain?: boolean
}>`
  display: flex;
  gap: 4px;
  height: 100%;
  align-items: center;

  img {
    ${({ theme }) => theme.breakpoints.down('md')} {
      width: 22px;
      height: 22px;
    }
  }
`

export const StyledSvg = styled(ArrrowSvg, transientOptions)<{ $isIn: number }>`
  color: ${({ theme, $isIn }) =>
    $isIn === 2 ? theme.color.text50 : theme.color.primary30};
  transform: rotate(180deg);
  transform: ${({ $isIn }) =>
    $isIn === 2 ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: all 0.4s ease;
  &.error {
    color: #fff;
  }
`
